import { render, staticRenderFns } from "./RectangleComp.vue?vue&type=template&id=b148abc2&scoped=true"
import script from "./RectangleComp.vue?vue&type=script&lang=js"
export * from "./RectangleComp.vue?vue&type=script&lang=js"
import style0 from "./RectangleComp.vue?vue&type=style&index=0&id=b148abc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b148abc2",
  null
  
)

export default component.exports